import React from "react";
import { connect } from "react-redux";
import { HorizontalLoader } from "../../widgets/Loader";
import { ScreenOverlay } from "../../widgets";

const Overlay = ({ show, text }) =>
    <ScreenOverlay show={show}>
        <ScreenOverlay.Content>
            <ScreenOverlay.Text>{text || ""}</ScreenOverlay.Text>
            <HorizontalLoader />
        </ScreenOverlay.Content>
    </ScreenOverlay>;

const mapStateToProps = state => ({ ...state.toast.overlay });

export default connect(mapStateToProps)(Overlay);